<script>
export default {
  data() {
    return {
      showCartEmpty: false,
    }
  },
  methods: {
    test() {
      $('#tab-1').click();
    },
    moveToList(id) {
      return this.$notify({
        type: 'success',
        message: 'Item (fake) moved to list!',
      });
    },
    moveAllToList(id) {
      return this.$notify({
        type: 'success',
        message: 'All Items (fake) moved to list!',
      });
    },
  },
  created() {
    this.$on('switchTab', this.test);
  }
}
</script>
